function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../theme";
export var ListPlaceholder = styled.div(_templateObject(), function (p) {
  return p.theme.variables.fonts.size.bigger1;
});